import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import {
  ContentContainer,
  PageSections,
  QuickLinks,
  VisitBanner,
} from '../../components';

import { getTemplateComponents, renderAlert } from '../../utils';

import './index.scss';

const LibraryServicesTemplate = ({ data, location }) => {
  const {
    directus: { rl_page },
  } = data;

  const page = rl_page.filter(
    (page) => page.introduction && page.template?.box_groups,
  )[0];

  const pageTitle = page?.title;
  const pageIntroduction = page?.introduction;
  const { pageSections } = getTemplateComponents(page);

  const alert = renderAlert();

  return (
    <Layout className='library-services-template' location={location}>
      <SEO title={pageTitle} />

      <ContentContainer
        alert={alert}
        location={location}
        body={pageIntroduction}
        title={pageTitle}
      >
        {pageSections && <PageSections pageSections={pageSections} />}
      </ContentContainer>

      <VisitBanner />
      <QuickLinks />
    </Layout>
  );
};

LibraryServicesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export const LibraryServicesTemplateQuery = graphql`
  query ($slug: String!) {
    directus {
      rl_page(
        filter: {
          slug: { _eq: $slug }
          template: { name: { _eq: "library-services" } }
        }
      ) {
        slug
        title
        introduction
        template {
          box_groups {
            group(filter: { name: { _eq: $slug } }) {
              page_sections(sort: "sort") {
                section_heading
                section_content
              }
            }
          }
        }
      }
    }
  }
`;

export default LibraryServicesTemplate;
